import { FingerprintIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Id = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <FingerprintIcon {...rest} size={Sizes[size]} color={fill} />;
};

Id.displayName = 'Id';
